LS.util.route({
	'$directory': {
		'$slug': {
			'$entry': {
				':load': 'profile',
				':unload': 'profile:unload'
			}
		}
	}
});